/* eslint-disable sort-keys */
import { A11yModule } from '@angular/cdk/a11y';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { FormatPhoneNumbersPipeModule } from 'src/app/pipes/format-phone-numbers/format-phone-numbers-pipe.module';
import { GlobalSearchSectionComponent } from './containers/global-search-section/global-search-section.component';
import { GlobalSearchComponent } from './containers/global-search.component';
import { GlobalSearchEffects } from './state/global-search.effects';
import { globalSearchReducer, globalSearchReducerKey } from './state/global-search.reducer';
import { GlobalSearchViewComponent } from './views/global-search-view.component';
@NgModule({
   imports: [
      CommonModule,
      OverlayModule,
      A11yModule,
      MatButtonModule,
      MatIconModule,
      FormatPhoneNumbersPipeModule,
      MatListModule,
      ReactiveFormsModule,
      RouterModule,
      LcsLoadingOverlayModule,
      EffectsModule.forFeature([GlobalSearchEffects]),
      StoreModule.forFeature(globalSearchReducerKey, globalSearchReducer),
   ],
   exports: [GlobalSearchComponent],
   declarations: [GlobalSearchComponent, GlobalSearchSectionComponent, GlobalSearchViewComponent],
})
export class GlobalSearchModule {}
